/**
 * PKCE (Proof Key for Code Exchange) utilities for OAuth 2.0.
 */

function base64UrlEncode (buffer: ArrayBuffer): string {
    const bytes = new Uint8Array(buffer)
    let binary = ''
    for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i])
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
}

export async function generatePKCE (): Promise<{ codeVerifier: string; codeChallenge: string }> {
    const array = new Uint8Array(32)
    crypto.getRandomValues(array)
    const codeVerifier = base64UrlEncode(array.buffer)

    const encoder = new TextEncoder()
    const data = encoder.encode(codeVerifier)
    const digest = await crypto.subtle.digest('SHA-256', data)
    const codeChallenge = base64UrlEncode(digest)

    return { codeVerifier, codeChallenge }
}
